import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useStore, { selectCountryTheme, selectBrand } from '@/hooks/client/useStore';
import { Suspense, lazy } from 'react';
import FavoriteRecipe from '@/features/recipe/FavoriteRecipe';

const Footer = lazy(() => import('@/common/Footer'));
const KeepFresh = lazy(() => import('@/features/keep-fresh/KeepFresh'));
const RecipeList = lazy(() => import('@/features/recipe/RecipeList'));

const css = {
  title: (color) => ({
    fontWeight: '800',
    color: color,
    textTransform: 'uppercase',
    textAlign: 'center',
    mt: 6,
    mb: 4,
  }),
  subtitle: (color) => ({
    textAlign: 'center',
    color: color,
    mx: 1,
  }),
};

const RecipeView = () => {
  const countryTheme = useStore(selectCountryTheme);
  const brand = useStore(selectBrand);

  return (
    <>
      <Box mx={2}>
        <Box>
          <Typography variant="h1" sx={css.title(countryTheme.navColor)}>
            Recetas para toda ocasión
          </Typography>
          <Typography variant="body1" sx={css.subtitle(countryTheme.secondaryColor)}>
            Encuentra las mejores recetas para sacar el máximo provecho de tus productos {brand}.
          </Typography>
        </Box>

        {/* recipe preview card */}
        <FavoriteRecipe />

        {/* recipe list with filter */}
        <Suspense fallback={null}>
          <RecipeList />
        </Suspense>

        {/* Keep fresh */}
        <Suspense fallback={null}>
          <KeepFresh />
        </Suspense>
      </Box>

      {/* footer */}
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </>
  );
};

export default RecipeView;
